export default class Page {
    constructor() {
        // Page
    }
}